
import { defineComponent, PropType } from 'vue'
import { AdBannerItem } from '@/types/AdBanner'

export default defineComponent({
  name: 'HomeAdBanner',

  props: {
    banner: {
      type: Object as PropType<AdBannerItem>,
      default: () => ({})
    }
    // NOTE: 抽象的なプロパティではなく親レイヤーで調整するのがいいと思います。
    // adType: {
    //   type: String
    // }
  }
})
